import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import './Premium.css';


class Premium extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }


    public render() {
      
        return (
            <div>
                <strong>Premium</strong>   
                <br />
                <strong mt-3>The End !</strong>   

            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(push(des))
    }
} 

export default connect(mapStateToProps, mapDispatchToProps)(Premium);